/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Property} from './Property';

/**
 * The TriggerAutomationEvent model module.
 * @module model/TriggerAutomationEvent
 * @version 1.0.0
 */
export class TriggerAutomationEvent {
  /**
   * Constructs a new <code>TriggerAutomationEvent</code>.
   * @alias module:model/TriggerAutomationEvent
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TriggerAutomationEvent</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TriggerAutomationEvent} obj Optional instance to populate.
   * @return {module:model/TriggerAutomationEvent} The populated <code>TriggerAutomationEvent</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TriggerAutomationEvent();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('globalType'))
        obj.globalType = ApiClient.convertToType(data['globalType'], 'String');
      if (data.hasOwnProperty('property'))
        obj.property = Property.constructFromObject(data['property']);
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
TriggerAutomationEvent.prototype._id = undefined;

/**
 * @member {String} title
 */
TriggerAutomationEvent.prototype.title = undefined;

/**
 * @member {String} description
 */
TriggerAutomationEvent.prototype.description = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
TriggerAutomationEvent.TypeEnum = {
  /**
   * value: "subscribe"
   * @const
   */
  subscribe: "subscribe"
};
/**
 * @member {module:model/TriggerAutomationEvent.TypeEnum} type
 */
TriggerAutomationEvent.prototype.type = undefined;

/**
 * Allowed values for the <code>globalType</code> property.
 * @enum {String}
 * @readonly
 */
TriggerAutomationEvent.GlobalTypeEnum = {
  /**
   * value: "none"
   * @const
   */
  none: "none",

  /**
   * value: "global"
   * @const
   */
  global: "global",

  /**
   * value: "property"
   * @const
   */
  property: "property"
};
/**
 * @member {module:model/TriggerAutomationEvent.GlobalTypeEnum} globalType
 */
TriggerAutomationEvent.prototype.globalType = undefined;

/**
 * @member {module:model/Property} property
 */
TriggerAutomationEvent.prototype.property = undefined;

/**
 * @member {Boolean} enabled
 */
TriggerAutomationEvent.prototype.enabled = undefined;

/**
 * @member {String} created
 */
TriggerAutomationEvent.prototype.created = undefined;

/**
 * @member {String} updated
 */
TriggerAutomationEvent.prototype.updated = undefined;

